import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Table } from '@thoughtspot/radiant-react/widgets/table/table';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import cx from 'classnames';
import React from 'react';
import styles from './mfa-list-view.module.scss';
export const MFAListview = ({ pageHeading, listViewProps, pageText, className, isModularHomeExperienceEnabled = false, ...rest }) => {
    const { loading, data } = listViewProps;
    const getContent = () => {
        if (isModularHomeExperienceEnabled) {
            return (React.createElement(Vertical, { className: loading && !data.length
                    ? styles.modularTableListFixed
                    : null },
                React.createElement(Table.ListView, { ...listViewProps, ...rest })));
        }
        return (React.createElement(Vertical, { className: loading ? styles.hiddenContainer : null },
            React.createElement(Table.ListView, { ...listViewProps, ...rest })));
    };
    return (React.createElement(Vertical, { className: cx(styles.container, className) },
        pageHeading && (React.createElement(Typography, { variant: "h2", className: styles.heading }, pageHeading)),
        React.createElement(Typography, { "data-testid": "page-text", variant: "caption", color: Colors.gray, className: styles.pageText }, pageText),
        React.createElement(Vertical, { className: styles.mfalistContainer },
            React.createElement(Vertical, null, getContent()))));
};
//# sourceMappingURL=mfa-list-view.js.map